import classNames from 'classnames';

import NOLStyles from '../styles.module.css';
import styles from './styles.module.css';

function NOLRowList({ selectedItem, selectedRowItem, selectRowItem }) {
    return (
        <div className={classNames(styles.rowItems, NOLStyles.border)}>
            {selectedItem['children'].map((item) => (
                <div
                    className={classNames(styles.rowItem, {
                        [styles.selected]: selectedRowItem && item.type == selectedRowItem.type,
                    })}
                    onClick={() => selectRowItem(item)}
                    key={item.type}
                >
                    {item.label}
                </div>
            ))}
        </div>
    );
}

export default NOLRowList;
